import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VcardModule } from '@shared/core/components/vcard';
import { FormForPaymentMethodModule } from '@shared/core/modules/forms/formTypes/forPaymentMethod';
import { FormForPaymentMethodRedirectModule } from '@shared/core/modules/forms/formTypes/forPaymentMethodRedirect';
import { FormForPaymentMethodFromProviderModule } from '@shared/core/modules/forms/formTypes/forPaymentMethodFromProvider';

import { ModalsTypesModule } from '../../modalsTypes';

import { ModalForCreditCardAddComponent } from './modal-for-credit-card-add.shared.component';

@NgModule({
    declarations: [
        ModalForCreditCardAddComponent,
    ],
    imports: [
        CommonModule,
        ModalsTypesModule,
        VcardModule,
        FormForPaymentMethodModule,
        FormForPaymentMethodRedirectModule,
        FormForPaymentMethodFromProviderModule
    ],
    exports: [
        ModalForCreditCardAddComponent,
    ],
})
export class ModalForCreditCardAddModule { }
